import { render, staticRenderFns } from "./RebuildingCommunity.vue?vue&type=template&id=1188c228&"
import script from "./RebuildingCommunity.vue?vue&type=script&lang=ts&"
export * from "./RebuildingCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./RebuildingCommunity.vue?vue&type=style&index=0&id=1188c228&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports